import { c as _c } from "react/compiler-runtime";
import { createContext, useCallback, use, useEffect, useState, type ReactNode } from 'react';
import isNil from 'lodash/isNil';

// Thanks to https://levelup.gitconnected.com/useonlinestatus-a-react-hook-to-know-when-your-app-is-offline-2d06e4e536a for the inspiration
const OnlineStatusContext = createContext(true);
export function OnlineStatusProvider(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  const [onlineStatus, setOnlineStatus] = useState(true);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOnlineStatus(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleOffline = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setOnlineStatus(true);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleOnline = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      window.addEventListener("offline", handleOffline);
      window.addEventListener("online", handleOnline);
      return () => {
        window.removeEventListener("offline", handleOffline);
        window.removeEventListener("online", handleOnline);
      };
    };
    t4 = [handleOffline, handleOnline];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] !== children || $[5] !== onlineStatus) {
    t5 = <OnlineStatusContext value={onlineStatus}>{children}</OnlineStatusContext>;
    $[4] = children;
    $[5] = onlineStatus;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
export const useOnlineStatus = () => {
  const context = use(OnlineStatusContext);
  if (isNil(context)) {
    throw new Error('useOnlineStatus must be used within a OnlineStatusProvider');
  }
  return context;
};